export const GERMAN_THIRD_PROVIDER_IMAGES = {
    COMMERZBANK: 'images/bank/commerzbank.svg',
    DEUTSCHE_BANK: 'images/bank/deutsche_bank.svg',
    SPARKASSE: 'images/bank/sparkasse.svg',
    POSTBANK: 'images/bank/postbank.svg',
    VOLKSBANK: 'images/bank/volksbank.svg',
    HYPOVEREINSBANK: 'images/bank/hypovereinsbank.svg'
};

export const IMAGE_CDN_URL = 'https://signup-static.iwoca.com';

export const animations = {
    successTick: `${IMAGE_CDN_URL}/images/animation/successTick.riv`
};

export const IMAGES = {
    LLOYDS: 'images/bank/lloyds_bank.svg',
    BARCLAYS: 'images/bank/barclays.svg',
    HSBC: 'images/bank/hsbc.svg',
    SANTANDER: 'images/bank/santander.svg',
    NATWEST: 'images/bank/natwest.svg',
    MBANK: 'images/bank/mbank.svg',
    ZACHODNI: 'images/bank/zachodni_bank.svg',
    IDEA: 'images/bank/idea_bank.svg',
    ING: 'images/bank/ing_bank.svg',
    POLSKI: 'images/bank/bank_polski.svg',
    SAGE50: 'images/accountancy/Sage50.png',
    KASHFLOW: 'images/accountancy/Kashflow.svg',
    SAGEONE: 'images/accountancy/SageOne.svg',
    AMAZON: 'images/ecommerce/Amazon.svg',
    EBAY: 'images/ecommerce/eBay.svg',
    PAYPAL: 'images/ecommerce/PayPal.svg',
    SAGEPAY: 'images/ecommerce/SagePay.svg',
    SHOPIFY: 'images/ecommerce/Shopify.svg',
    SKRILL: 'images/ecommerce/Skrill.svg',
    STRIPE: 'images/ecommerce/Stripe.svg',
    EKM: 'images/ecommerce/EKM.svg',
    NOTHS: 'images/ecommerce/NOTHS.png'
};

export const currencySymbols = {
    PLN: 'zł',
    EUR: '€',
    GBP: '£'
};

export const localeCurrency = {
    uk: 'GBP',
    de: 'EUR'
};
